import { connect } from 'react-redux'
import DesktopHelpers from 'helpers/DesktopHelpers'
import { getUnreadNotificationsCount } from 'data/notifications/selectors'

declare global {
  interface Window {
    electron?: any
  }
}

const enhance = connect((state: any) => ({
  count: getUnreadNotificationsCount(state),
}))

export type DesktopBadgeProps = {
  count: number
}

const DesktopBadge = ({ count }: DesktopBadgeProps) => {
  if (!DesktopHelpers.isAppDesktop()) {
    return null
  }
  window.electron.ipcRenderer.send('app.setBadgeCount', count)
  return null
}

export default enhance(DesktopBadge)
